<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame _idGenObjectStyle-Disabled" id="_idContainer002">
<img alt="" class="_idGenObjectAttribute-1" src="image/Nettle_Pasta_.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ForestHome_ebook.vue?0fd7d6a0